(function () {
    'use strict';
    angular.module('Login')
        .controller('TwoFactorAuthModalController',
            function (
                $uibModalInstance,
                AuthenticationService,
                data,
                authType,
                $cookies,
                $interval,
                $scope,
                $uibModal
            ) {
                var vm = this;
                vm.userData = angular.copy(data)
                vm.authType = angular.copy(authType);
                vm.closeModal = closed;
                vm.resendCode = resendCode;
                vm.submit = submit;
                vm.changeAuthentication = changeAuthentication;
                vm.changed = countCharacter;
                vm.count = 0;
                init();
                function init() {
                    $cookies.put('twoFactorVerifitacion', true);

                    sendTokenToEmail(vm.userData)
                    vm.email = hideUserEmail(vm.userData.config.data.username);
                    if (vm.authType.tokenType === 'email') {
                        vm.authenication = false;
                        return
                    }
                    vm.authenication = true;
                }


                function closed() {
                    clearCredentials();
                    $uibModalInstance.close()
                }

                function changeAuthentication() {
                    openWindows()
                }

                function hideUserEmail(my_string) {
                    let first_six_chars = my_string.slice(0, 5);
                    return first_six_chars + 'xxx@xxx.xxx';
                }

                function countCharacter(data) {
                    if (data.length > 5) {
                        vm.disabled = true
                        return;
                    }
                    vm.disabled = false
                }

                function submit() {
                    if (vm.authenication) {
                        verifyAppToken();
                    } else {
                        verifyEmailToken();
                    }
                }

                function verifyEmailToken() {
                    AuthenticationService.twoFactorEmailVerifitacion(vm.userData.data.userId, vm.verificationCode,
                        res => {
                            if (res.data) {
                                $cookies.remove('twoFactorVerifitacion')
                                $uibModalInstance.close(res.data);
                                return
                            }
                            vm.error = true
                        },
                        err => {
                            console.log(err);
                            vm.error = true
                        })
                }

                function verifyAppToken() {
                    AuthenticationService.twoFactorAppVerifitacion(vm.userData.data.userId, vm.verificationCode,
                        res => {
                            if (res.data) {
                                $cookies.remove('twoFactorVerifitacion')
                                $uibModalInstance.close(res.data);
                                return
                            }
                            vm.error = true
                        },
                        err => {
                            console.log(err);
                            vm.error = true
                        })
                }

                function clearCredentials() {
                    AuthenticationService.clearCredentials();
                    sessionStorage.removeItem('auth');
                    $cookies.remove('twoFactorVerifitacion');
                }

                function sendTokenToEmail() {
                    AuthenticationService.twoFactorSendTokenToEmail(vm.userData.data.access_token,
                        res => {

                        }, err => {

                        });
                }

                function resendCode() {
                    sendTokenToEmail();
                    vm.count = 300;
                    $interval(() => {
                        vm.count--
                    }, 1000)

                }

                function openWindows() {
                    $uibModal.open({
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: '../auth/templates/modal/confirmChangeAuthentication.html',
                        controller: 'ConfirmChangeAuthModalController',
                        controllerAs: 'vm',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'warning-modal',
                        size: 'sm',
                        resolve: {
                            data: () => {
                                return data;
                            }
                        }
                        //appendTo: $('body')
                    }).result.then(response => {
                        if (response) {
                            authMethod();
                            return;
                        }

                    })
                }

                function authMethod() {
                    vm.count = 0;

                    if (vm.authenication) {
                        vm.authenication = false;
                        vm.type = 'EMAIL';
                        vm.verificationCode = "";
                        vm.error = false;
                    } else {
                        vm.authenication = true;
                        vm.type = 'AUTHENTICATOR';
                        vm.verificationCode = "";
                        vm.error = false;
                    }

                    AuthenticationService.changeTypeAuthMethod(vm.userData.data.access_token, vm.type,
                        res => {
                            console.log(res)
                        },
                        err => {
                            console.log(err)
                        })
                }

            }
        );
})()



//////////////////
// WEBPACK FOOTER
// ./auth/js/controllers/modal/twoFactorAuthModalController.js
// module id = 148
// module chunks = 0